import {AuthModel} from '../auth/core/_models'
import {isOnPremisesInstallation} from '../auth/core/onPremisesAccess'

/**
 * «پیش‌فاکتور» in «امکانات تازه» (user decision 2026-10-13): no window opens at sign-in; the header's
 * icon shakes until the list is opened, and the item opens this introduction (ProformaIntroGate).
 */
export const PROFORMA_INTRO_EVENT = 'mp:proforma-intro'

/** The announcement's id in the user's seen list (whatsNewSeen); a new announcement takes a new id. */
export const PROFORMA_ANNOUNCEMENT = 'proforma-1405-07'

export const SALES_INVOICES_PATH = '/apps/invoice-management/invoices'

/** Route state with which the sales invoices list opens «پیش‌فاکتور جدید». */
export const OPEN_NEW_PROFORMA_STATE = {openProforma: true}

export const openProformaIntro = (): void => {
  window.dispatchEvent(new Event(PROFORMA_INTRO_EVENT))
}

export const wantsNewProforma = (state: unknown): boolean =>
  typeof state === 'object' &&
  state !== null &&
  (state as {openProforma?: unknown}).openProforma === true

/**
 * Whoever works in a business; a support operator inside a customer's panel is not the customer. The bank's own
 * install has no proforma (the user, 2026-10-26).
 */
export const shouldAnnounceProforma = (user?: AuthModel | null) =>
  Boolean(user && !user.support && Number(user.cpi || 0) > 0 && !isOnPremisesInstallation(user))

/** The list offers «پیش‌فاکتور جدید» where it offers the web form (InvoicesListAdd). */
export const canOpenNewProforma = (user?: AuthModel | null) =>
  process.env.REACT_APP_MEGAPAY_WEB === 'true' && !isOnPremisesInstallation(user)
